import { Card, Button, Form, Col, Row } from "react-bootstrap"
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CoinIcon from '@mui/icons-material/Paid';
import reporteConsumoStore from "../../../../lib/store/reporte_consumo_store";
import dayjs from "dayjs";

const ConsumosTotales = () => {

    const {
        editarMostrarFiltros, mensajesSms, mensajesEmail, mensajesWhatsapp, mensajesVoz,
        editarVehiculos, editarContactos, editarAlertas,
        sms, email, whatsapp, voz,
    } = reporteConsumoStore();

    const style2Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 1 línea
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };

    const mostrarFiltroReporte = () => {
        let mensajes = [
            ...(Array.isArray(mensajesSms) ? mensajesSms : []),
            ...(Array.isArray(mensajesEmail) ? mensajesEmail : []),
            ...(Array.isArray(mensajesVoz) ? mensajesVoz : []),
            ...(Array.isArray(mensajesWhatsapp) ? mensajesWhatsapp : []),
        ];
        var groups = new Set();
        editarVehiculos(
            mensajes
                .filter(item => {
                    if (groups.has(item['idvehiculo'])) return false;
                    groups.add(item['idvehiculo']);
                    return true;
                })
                .map((item) => ({
                    value: item['idvehiculo'],
                    label: `${item['vehiculo']}`,
                }))
        );
        groups = new Set();
        editarContactos(
            mensajes
                .filter(item => {
                    if (groups.has(item['destinatarioId'])) return false;
                    groups.add(item['destinatarioId']);
                    return true;
                })
                .map((item) => ({
                    value: item['destinatarioId'],
                    label: `${item['destinatario']}`,
                }))
        );
        groups = new Set();
        editarAlertas(
            mensajes
                .filter(item => {
                    if (groups.has(item['idTipoAlerta'])) return false;
                    groups.add(item['idTipoAlerta']);
                    return true;
                })
                .map((item) => ({
                    value: item['idTipoAlerta'],
                    label: `${item['tipoAlerta']}`,
                }))
        );
        editarMostrarFiltros(true);
    };

    const totalItem = (icon, item, title, type) => {
        let separator = <div style={{ maxWidth: '1px' }}><div className="vr" style={{ marginLeft: '40px', height: '70px', backgroundColor: 'lightgrey' }} ></div></div>

        return (

            <Col xs={12} md={2} xxl={2} >
                <Row
                    className="w-100 d-flex flex-nowrap justify-content-center align-items-start"
                    title={title}
                >
                    <div style={{
                        width: 40,
                        height: 40,
                        cursor: 'help'
                    }}
                    >
                        {icon}
                    </div>

                    {/* Tipo de Indicador */}
                    <Col >
                        <div className="fw-bold label-detail-card"> {type} </div>
                        <br />
                        <div className="fw-bold label-detail-card" style={{ marginLeft: '-40px' }}> {item ? item.utilizadas : 0} / {item ? item.cantidad : 0} &nbsp; &nbsp; ${item ? item.costo_total.toFixed(2) : (0).toFixed(2)} </div>
                    </Col>

                    {separator}
                </Row>
            </Col>
        )
    }

    const costoGlobalItem = () => {
        let separator = <div style={{ maxWidth: '1px' }}><div className="vr" style={{ height: '80px', backgroundColor: 'lightgrey' }} ></div></div>
        let totalSMS = sms !== null ? sms.costo_total : 0;
        let totalEmail = email !== null ? email.costo_total : 0;
        let totalWhatsapp = whatsapp !== null ? whatsapp.costo_total : 0;
        let totalVoz = voz !== null ? voz.costo_total : 0;
        let costoGlobal = totalSMS + totalEmail + totalWhatsapp + totalVoz;

        return (
            <Col xs={12} md={2} xxl={2} >

                <Row
                    className="w-100 d-flex flex-nowrap justify-content-center align-items-start"
                    title={'Total Utilizados'}
                >
                    <div style={{
                        width: 40,
                        height: 40,
                        cursor: 'help'
                    }}
                    >
                        <CoinIcon style={{ color: "#c00f1b" }} />
                    </div>

                    {/* Tipo de Indicador */}
                    <Col >
                        <div className="fw-bold label-detail-card"> {'Costo total'} </div>
                        <br />
                        <div className="fw-bold label-detail-card" style={{ marginLeft: '-40px' }}> ${costoGlobal.toFixed(2)} </div>
                    </Col>

                </Row>
            </Col>
        )
    }

    const filtroConsumoItem = () => {
        return (
            <Row
                className="m-0 p-0 w-100 d-flex justify-content-evenly align-items-end"
            >
                <Col></Col>
                <Col md={2} xs={4} className="pe-3">

                    <Button
                        variant="primary"
                        onClick={mostrarFiltroReporte}
                        className="w-100"

                    >
                        Filtrar
                    </Button>

                </Col>
            </Row>


        );
    };

    const datosDisponibles = () => sms !== null || email !== null || whatsapp !== null && voz !== null;

    const obtenerTooltip = (title, item) => {
        let labelTitle = "";

        if (item && item.hasOwnProperty('previo')) {
            labelTitle = title + "\n" +
                "-Total usado: " + item.utilizadas + "\n" +
                "-Total configurado: " + item.cantidad + "\n" +
                "-Credito consumido: $ " + item.costo_total.toFixed(2) + "\n" +
                "-Total configurado anterior: " + item.previo.cantidad + "\n" +
                "-Fecha de configuración anterior: " + dayjs(item.previo.fecha, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
        }
        else {
            labelTitle = title + "\n" +
                "-Total usado: " + '0' + "\n" +
                "-Total configurado: " + '0' + "\n" +
                "-Credito consumido: $" + '0.00' + "\n" +
                "-Total configurado anterior: " + '0' + "\n" +
                "-Fecha de configuración anterior: " + 'N/A';
        }

        return labelTitle;
    }

    const listaTotales = [

        totalItem(
            <SmsIcon style={{ color: "#c00f1b" }} />,
            sms,
            obtenerTooltip('Envio de SMS:', sms),
            'SMS'
        ),
        totalItem(
            <EmailIcon style={{ color: "#c00f1b" }} />,
            email,
            obtenerTooltip('Envio de Email:', email),
            'Correo'
        ),
        totalItem(
            <WhatsAppIcon style={{ color: "#c00f1b" }} />,
            whatsapp,
            obtenerTooltip('Envio de Whatsapp:', whatsapp),
            'WhatsApp'
        ),
        totalItem(
            <RecordVoiceOverIcon style={{ color: "#c00f1b" }} />,
            voz,
            obtenerTooltip('Envio de mensajes de voz:', voz),
            'Voz'
        ),
        costoGlobalItem(),

    ];

    return (
        <Card className="p-3 mt-3">
            <Row className="p-3">
                <Col>
                    <Row className="g-3 align-items-center justify-content-between" >
                        {listaTotales.map((view, index) => {
                            return [
                                view,
                            ]
                        })}
                    </Row>
                </Col>
            </Row>
        </Card>
    );
}

export default ConsumosTotales;